<template style="touch-action: none;">
  <div></div>
</template>

<script>
  Array.prototype.remove = function() {
      var what, a = arguments, L = a.length, ax;
      while (L && this.length) {
          what = a[--L];
          while ((ax = this.indexOf(what)) !== -1) {
              this.splice(ax, 1);
          }
      }
      return this;
  };
  export default {
    name: 'App',
    props: ['baseURL','baseLINE','baseAPI','baseADMIN','tax'],
    components: {
    },
    data(){
      return{
      }
    },
    
    
    mounted() {
      let query = this.$route.query;
      let str_groupid = query['Groupid'];
      let str_userid = query['Userid'];
      let type = query['Type'];
      localStorage.setItem("Groupid",str_groupid);
      localStorage.setItem("Userid",str_userid);
      console.log(type);
      if(type == "gps"|| type=="GPS"){
        console.log("GOTO_GPS")
        location.href="./card"
      }else if(type=="wifi"|| type=="WIFI"){
        console.log("GOTO_WIFI")
        location.href="./wifiCard"
      }else if(type=="leave"|| type=="LEAVE"){
        console.log("GOTO_WIFI")
        location.href="./leaveCard"
      }
      console.log(str_groupid,str_userid,type);
      //this.getWifi();
    },
    methods:{
    }
  }
  </script>
  <style>
    .text-small{
      font-size: 8px;
    }
    .position-center{
      position: relative;
      margin: auto;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  </style>